export class MultiSelectItem {
  id: string;
  value: string;

  public constructor(id: string, value: string) {
    this.id = id;
    this.value = value;
  }
}
